import { useLocation } from 'react-router-dom'

import { Columns, LoadingModule } from '@domain-group/suit-theme'

import { useNumericParams } from '@domain-group/react-hooks'

import NotificationBannerLocation from '@components/NotificationBannerLocation'
import NotificationModuleLocation from '@components/NotificationModuleLocation'

import useCampaign from '@hooks/useCampaign'
import useCampaignPortals from '@hooks/useCampaignPortals'
import usePortals from '@hooks/usePortals'
import useSelector from '@hooks/useSelector'

import ActivePortals from '../ActivePortals'
import AvailablePortals from '../AvailablePortals'
import PageLayout from '../PageLayout'
import PortalSettings from '../PortalSettings'
import PortalTools from '../PortalTools'
import SyncHistory from '../SyncHistory'

const PageContent = () => {
  useLocation()

  const { campaignId } = useNumericParams()

  const campaignPayload = useCampaign({ id: campaignId })

  usePortals({ performHttpRequests: !!campaignId })

  const campaignPortalsPayload = useCampaignPortals({
    filters: {
      campaign_id: campaignId,
    },
    performHttpRequests: !!campaignId,
  })

  const { activePortalIds } = campaignPortalsPayload

  const loading = useSelector((reduxState) => {
    const { campaignPortals, campaignPortalSyncs, portals } = reduxState
    return campaignPortals.loading && campaignPortalSyncs.loading && portals.loading
  })

  return (
    // @ts-expect-error TS2322
    <PageLayout campaignPayload={campaignPayload} activeTabBarItemKey="details">
      <Columns.Main>
        <NotificationBannerLocation locationKey="agency.campaign.portals.banner" />

        <LoadingModule loading={loading} times={3} />

        {!loading && (
          <>
            <ActivePortals campaignPortalsPayload={campaignPortalsPayload} />

            <AvailablePortals activePortalIds={activePortalIds} />

            <SyncHistory campaignId={campaignId} />
          </>
        )}
      </Columns.Main>

      <Columns.Sidebar>
        <NotificationModuleLocation locationKey="agency.campaign.portals.sidebar" />

        <PortalTools campaignPayload={campaignPayload} />

        <PortalSettings campaignId={campaignId} />
      </Columns.Sidebar>
    </PageLayout>
  )
}

export default PageContent
